import { ComponentPropsWithoutRef } from "react";

export const DoubleLeftArrowIcon = ({
  ...props
}: ComponentPropsWithoutRef<"svg">) => {
  return (
    <svg {...props} viewBox="0 0 14 14">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.716 11.164c.092.038.19.058.29.057.196.01.388-.06.534-.192a.757.757 0 0 0 0-1.069L3.514 6.934 6.54 3.91a.756.756 0 0 0-1.069-1.01l-3.5 3.5a.756.756 0 0 0 0 1.07l3.5 3.53c.07.07.153.127.245.165Zm5.333-.195c.129.147.31.237.504.252a.756.756 0 0 0 .504-1.26L9.032 6.933l3.025-3.025a.757.757 0 0 0-1.008-1.01l-3.53 3.47a.756.756 0 0 0 0 1.07l3.53 3.53Z"
        fill="currentColor"
      />
    </svg>
  );
};
